module.exports = __webpack_public_path__ + "img/s3-1.04fdb38f.jpg";